module.exports = __webpack_public_path__ + "static/03-94d1fbceb512062fd5f1e1a2e327059e.jpg";